// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/auth/v1/auth.proto" (package "agency.auth.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * Claims represents the authenticated identity and authorization context.
 * All messages on NATS must include Claims in the Envelope.
 *
 * @generated from protobuf message agency.auth.v1.Claims
 */
export interface Claims {
    /**
     * sub (subject) is the unique identifier for the authenticated entity.
     *
     * @generated from protobuf field: string sub = 1
     */
    sub: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * role is the RBAC role for this claim.
     *
     * @generated from protobuf field: agency.auth.v1.RBACRole role = 4
     */
    role: RBACRole;
    /**
     * iss (issuer) is the identity provider that issued this claim.
     *
     * @generated from protobuf field: string iss = 5
     */
    iss: string;
    /**
     * aud (audience) is the intended recipient(s) of this claim.
     *
     * @generated from protobuf field: repeated string aud = 6
     */
    aud: string[];
    /**
     * iat (issued at) is the time the claim was issued.
     *
     * @generated from protobuf field: google.protobuf.Timestamp iat = 7
     */
    iat?: Timestamp;
    /**
     * exp (expiration) is the time after which the claim is no longer valid.
     *
     * @generated from protobuf field: google.protobuf.Timestamp exp = 8
     */
    exp?: Timestamp;
    /**
     * nbf (not before) is the time before which the claim is not valid.
     *
     * @generated from protobuf field: google.protobuf.Timestamp nbf = 9
     */
    nbf?: Timestamp;
    /**
     * jti (JWT ID) is a unique identifier for this claim.
     *
     * @generated from protobuf field: string jti = 10
     */
    jti: string;
    /**
     * scopes are additional permission scopes.
     *
     * @generated from protobuf field: repeated string scopes = 11
     */
    scopes: string[];
    /**
     * nats_account is the NATS account for protocol-level tenant isolation.
     *
     * @generated from protobuf field: string nats_account = 12
     */
    natsAccount: string;
}
/**
 * MintRequest requests the creation of new scoped credentials.
 *
 * @generated from protobuf message agency.auth.v1.MintRequest
 */
export interface MintRequest {
    /**
     * parent_claims are the claims of the requesting entity.
     *
     * @generated from protobuf field: agency.auth.v1.Claims parent_claims = 1
     */
    parentClaims?: Claims;
    /**
     * tenant is the tenant for the new credentials.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace for the new credentials.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * session is the session identifier for session-scoped credentials.
     *
     * @generated from protobuf field: string session = 4
     */
    session: string;
    /**
     * role is the requested role.
     *
     * @generated from protobuf field: agency.auth.v1.RBACRole role = 5
     */
    role: RBACRole;
    /**
     * ttl_seconds is the time-to-live in seconds for the new credentials.
     *
     * @generated from protobuf field: int64 ttl_seconds = 6
     */
    ttlSeconds: bigint;
    /**
     * scopes are additional permission scopes.
     *
     * @generated from protobuf field: repeated string scopes = 7
     */
    scopes: string[];
}
/**
 * ValidateRequest requests validation of claims.
 *
 * @generated from protobuf message agency.auth.v1.ValidateRequest
 */
export interface ValidateRequest {
    /**
     * claims are the claims to validate.
     *
     * @generated from protobuf field: agency.auth.v1.Claims claims = 1
     */
    claims?: Claims;
    /**
     * required_scopes are the scopes that must be present.
     *
     * @generated from protobuf field: repeated string required_scopes = 2
     */
    requiredScopes: string[];
}
/**
 * ValidateResponse is the result of claims validation.
 *
 * @generated from protobuf message agency.auth.v1.ValidateResponse
 */
export interface ValidateResponse {
    /**
     * valid indicates whether the claims are valid.
     *
     * @generated from protobuf field: bool valid = 1
     */
    valid: boolean;
    /**
     * reason provides details if the claims are invalid.
     *
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
    /**
     * expires_in_seconds is the remaining TTL if valid.
     *
     * @generated from protobuf field: int64 expires_in_seconds = 3
     */
    expiresInSeconds: bigint;
}
/**
 * RolePermissions defines the permission set for an RBAC role.
 *
 * @generated from protobuf message agency.auth.v1.RolePermissions
 */
export interface RolePermissions {
    /**
     * role is the RBAC role.
     *
     * @generated from protobuf field: agency.auth.v1.RBACRole role = 1
     */
    role: RBACRole;
    /**
     * permissions are the granted permissions for this role.
     *
     * @generated from protobuf field: repeated agency.auth.v1.Permission permissions = 2
     */
    permissions: Permission[];
    /**
     * description explains the role's purpose.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * FetchRequest requests credential retrieval.
 *
 * @generated from protobuf message agency.auth.v1.FetchRequest
 */
export interface FetchRequest {
    /**
     * credential_type is the type of credential to fetch.
     *
     * @generated from protobuf field: agency.auth.v1.CredentialType credential_type = 1
     */
    credentialType: CredentialType;
    /**
     * tenant is the tenant context (for tool credentials).
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace context (for tool credentials).
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * tool_name is the tool requiring credentials (for tool credentials).
     *
     * @generated from protobuf field: string tool_name = 4
     */
    toolName: string;
    /**
     * provider is the LLM provider name (for LLM credentials).
     *
     * @generated from protobuf field: string provider = 5
     */
    provider: string;
    /**
     * credential_key is the specific credential identifier.
     *
     * @generated from protobuf field: string credential_key = 6
     */
    credentialKey: string;
}
/**
 * FetchResponse returns fetched credentials.
 *
 * @generated from protobuf message agency.auth.v1.FetchResponse
 */
export interface FetchResponse {
    /**
     * credential_type is the type of credential returned.
     *
     * @generated from protobuf field: agency.auth.v1.CredentialType credential_type = 1
     */
    credentialType: CredentialType;
    /**
     * secret is the credential secret value.
     *
     * @generated from protobuf field: string secret = 2
     */
    secret: string;
    /**
     * metadata contains credential metadata (type, provider, etc).
     *
     * @generated from protobuf field: map<string, string> metadata = 3
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * expires_at is when the credential expires (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 4
     */
    expiresAt?: Timestamp;
    /**
     * rotation_due_at is when credential rotation is recommended.
     *
     * @generated from protobuf field: google.protobuf.Timestamp rotation_due_at = 5
     */
    rotationDueAt?: Timestamp;
    /**
     * provider_type describes the credential provider backend.
     *
     * @generated from protobuf field: string provider_type = 6
     */
    providerType: string;
}
/**
 * CredentialRotationEvent signals credential rotation.
 *
 * @generated from protobuf message agency.auth.v1.CredentialRotationEvent
 */
export interface CredentialRotationEvent {
    /**
     * credential_type is the type of credential rotated.
     *
     * @generated from protobuf field: agency.auth.v1.CredentialType credential_type = 1
     */
    credentialType: CredentialType;
    /**
     * credential_key is the credential identifier.
     *
     * @generated from protobuf field: string credential_key = 2
     */
    credentialKey: string;
    /**
     * tenant is the tenant context (if applicable).
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace is the workspace context (if applicable).
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * provider is the credential provider.
     *
     * @generated from protobuf field: string provider = 5
     */
    provider: string;
    /**
     * rotated_at is when the rotation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp rotated_at = 6
     */
    rotatedAt?: Timestamp;
    /**
     * rotation_reason explains why rotation occurred.
     *
     * @generated from protobuf field: string rotation_reason = 7
     */
    rotationReason: string;
    /**
     * next_rotation_at is when the next rotation is scheduled.
     *
     * @generated from protobuf field: google.protobuf.Timestamp next_rotation_at = 8
     */
    nextRotationAt?: Timestamp;
}
/**
 * RegisterRequest registers a new credential.
 *
 * @generated from protobuf message agency.auth.v1.RegisterRequest
 */
export interface RegisterRequest {
    /**
     * credential_type is the type of credential.
     *
     * @generated from protobuf field: agency.auth.v1.CredentialType credential_type = 1
     */
    credentialType: CredentialType;
    /**
     * credential_key is the identifier for this credential.
     *
     * @generated from protobuf field: string credential_key = 2
     */
    credentialKey: string;
    /**
     * tenant scopes the credential (for tool credentials).
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace scopes the credential (for tool credentials).
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * secret is the credential secret value.
     *
     * @generated from protobuf field: string secret = 5
     */
    secret: string;
    /**
     * metadata contains credential metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 6
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * ttl_seconds is the time-to-live in seconds (0 = no expiration).
     *
     * @generated from protobuf field: int64 ttl_seconds = 7
     */
    ttlSeconds: bigint;
}
/**
 * RegisterResponse confirms credential registration.
 *
 * @generated from protobuf message agency.auth.v1.RegisterResponse
 */
export interface RegisterResponse {
    /**
     * credential_key is the registered credential identifier.
     *
     * @generated from protobuf field: string credential_key = 1
     */
    credentialKey: string;
    /**
     * registered_at is when the credential was registered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp registered_at = 2
     */
    registeredAt?: Timestamp;
    /**
     * expires_at is when the credential expires (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 3
     */
    expiresAt?: Timestamp;
}
/**
 * RotateRequest triggers credential rotation.
 *
 * @generated from protobuf message agency.auth.v1.RotateRequest
 */
export interface RotateRequest {
    /**
     * credential_key is the credential to rotate.
     *
     * @generated from protobuf field: string credential_key = 1
     */
    credentialKey: string;
    /**
     * credential_type is the type of credential.
     *
     * @generated from protobuf field: agency.auth.v1.CredentialType credential_type = 2
     */
    credentialType: CredentialType;
    /**
     * tenant scopes the rotation (if applicable).
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace scopes the rotation (if applicable).
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * grace_period is the overlap period for old credential.
     *
     * @generated from protobuf field: google.protobuf.Duration grace_period = 5
     */
    gracePeriod?: Duration;
}
/**
 * RotateResponse confirms rotation completion.
 *
 * @generated from protobuf message agency.auth.v1.RotateResponse
 */
export interface RotateResponse {
    /**
     * credential_key is the rotated credential identifier.
     *
     * @generated from protobuf field: string credential_key = 1
     */
    credentialKey: string;
    /**
     * rotated_at is when rotation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp rotated_at = 2
     */
    rotatedAt?: Timestamp;
    /**
     * new_expires_at is when the new credential expires (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp new_expires_at = 3
     */
    newExpiresAt?: Timestamp;
    /**
     * grace_period_ends_at is when the old credential is invalidated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp grace_period_ends_at = 4
     */
    gracePeriodEndsAt?: Timestamp;
}
/**
 * RevokeRequest revokes a credential.
 *
 * @generated from protobuf message agency.auth.v1.RevokeRequest
 */
export interface RevokeRequest {
    /**
     * credential_key is the credential to revoke.
     *
     * @generated from protobuf field: string credential_key = 1
     */
    credentialKey: string;
    /**
     * credential_type is the type of credential.
     *
     * @generated from protobuf field: agency.auth.v1.CredentialType credential_type = 2
     */
    credentialType: CredentialType;
    /**
     * tenant scopes the revocation (if applicable).
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace scopes the revocation (if applicable).
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * reason explains why revocation occurred.
     *
     * @generated from protobuf field: string reason = 5
     */
    reason: string;
}
/**
 * RevokeResponse confirms credential revocation.
 *
 * @generated from protobuf message agency.auth.v1.RevokeResponse
 */
export interface RevokeResponse {
    /**
     * credential_key is the revoked credential identifier.
     *
     * @generated from protobuf field: string credential_key = 1
     */
    credentialKey: string;
    /**
     * revoked_at is when revocation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 2
     */
    revokedAt?: Timestamp;
}
/**
 * CredentialCacheEntry represents a cached credential.
 *
 * @generated from protobuf message agency.auth.v1.CredentialCacheEntry
 */
export interface CredentialCacheEntry {
    /**
     * credential_key is the credential identifier.
     *
     * @generated from protobuf field: string credential_key = 1
     */
    credentialKey: string;
    /**
     * credential_type is the type of credential.
     *
     * @generated from protobuf field: agency.auth.v1.CredentialType credential_type = 2
     */
    credentialType: CredentialType;
    /**
     * secret is the cached credential secret.
     *
     * @generated from protobuf field: string secret = 3
     */
    secret: string;
    /**
     * cached_at is when the credential was cached.
     *
     * @generated from protobuf field: google.protobuf.Timestamp cached_at = 4
     */
    cachedAt?: Timestamp;
    /**
     * expires_at is when the cache entry expires.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 5
     */
    expiresAt?: Timestamp;
    /**
     * metadata contains credential metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 6
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * RevocationEvent notifies that a JWT token or subject has been revoked.
 * Published to revocations.<harness>.<tenant> subject.
 *
 * @generated from protobuf message agency.auth.v1.RevocationEvent
 */
export interface RevocationEvent {
    /**
     * sub is the subject identifier being revoked.
     *
     * @generated from protobuf field: string sub = 1
     */
    sub: string;
    /**
     * tenant scopes the revocation.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * jti is the JWT ID being revoked (optional, if revoking specific token).
     *
     * @generated from protobuf field: string jti = 3
     */
    jti: string;
    /**
     * reason explains why revocation occurred.
     *
     * @generated from protobuf field: string reason = 4
     */
    reason: string;
    /**
     * revoked_at is when revocation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 5
     */
    revokedAt?: Timestamp;
    /**
     * revoked_by is who initiated the revocation.
     *
     * @generated from protobuf field: string revoked_by = 6
     */
    revokedBy: string;
}
/**
 * RBACRole defines the role-based access control roles.
 *
 * @generated from protobuf enum agency.auth.v1.RBACRole
 */
export enum RBACRole {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: RBAC_ROLE_UNSPECIFIED = 0;
     */
    RBAC_ROLE_UNSPECIFIED = 0,
    /**
     * VIEWER can read sessions and results.
     *
     * @generated from protobuf enum value: RBAC_ROLE_VIEWER = 1;
     */
    RBAC_ROLE_VIEWER = 1,
    /**
     * OPERATOR can create and manage sessions.
     *
     * @generated from protobuf enum value: RBAC_ROLE_OPERATOR = 2;
     */
    RBAC_ROLE_OPERATOR = 2,
    /**
     * ADMIN can manage workspace configuration and users.
     *
     * @generated from protobuf enum value: RBAC_ROLE_ADMIN = 3;
     */
    RBAC_ROLE_ADMIN = 3,
    /**
     * OWNER has full control over the tenant.
     *
     * @generated from protobuf enum value: RBAC_ROLE_OWNER = 4;
     */
    RBAC_ROLE_OWNER = 4,
    /**
     * SERVICE is for service-to-service authentication.
     *
     * @generated from protobuf enum value: RBAC_ROLE_SERVICE = 5;
     */
    RBAC_ROLE_SERVICE = 5,
    /**
     * SYSTEM is for internal harness-to-harness communication.
     *
     * @generated from protobuf enum value: RBAC_ROLE_SYSTEM = 6;
     */
    RBAC_ROLE_SYSTEM = 6
}
/**
 * Permission defines granular access control permissions.
 *
 * @generated from protobuf enum agency.auth.v1.Permission
 */
export enum Permission {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: PERMISSION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SESSION_CREATE allows creating new sessions.
     *
     * @generated from protobuf enum value: PERMISSION_SESSION_CREATE = 1;
     */
    SESSION_CREATE = 1,
    /**
     * SESSION_READ allows reading session state and results.
     *
     * @generated from protobuf enum value: PERMISSION_SESSION_READ = 2;
     */
    SESSION_READ = 2,
    /**
     * SESSION_CANCEL allows canceling sessions.
     *
     * @generated from protobuf enum value: PERMISSION_SESSION_CANCEL = 3;
     */
    SESSION_CANCEL = 3,
    /**
     * SESSION_INTERRUPT allows interrupting sessions with steering.
     *
     * @generated from protobuf enum value: PERMISSION_SESSION_INTERRUPT = 4;
     */
    SESSION_INTERRUPT = 4,
    /**
     * TOOL_EXECUTE allows executing tools.
     *
     * @generated from protobuf enum value: PERMISSION_TOOL_EXECUTE = 5;
     */
    TOOL_EXECUTE = 5,
    /**
     * TOOL_REGISTER allows registering new tools.
     *
     * @generated from protobuf enum value: PERMISSION_TOOL_REGISTER = 6;
     */
    TOOL_REGISTER = 6,
    /**
     * WORKSPACE_READ allows reading workspace configuration.
     *
     * @generated from protobuf enum value: PERMISSION_WORKSPACE_READ = 7;
     */
    WORKSPACE_READ = 7,
    /**
     * WORKSPACE_WRITE allows modifying workspace configuration.
     *
     * @generated from protobuf enum value: PERMISSION_WORKSPACE_WRITE = 8;
     */
    WORKSPACE_WRITE = 8,
    /**
     * CONTEXT_READ allows reading context data (prompts, skills, artifacts).
     *
     * @generated from protobuf enum value: PERMISSION_CONTEXT_READ = 9;
     */
    CONTEXT_READ = 9,
    /**
     * CONTEXT_WRITE allows modifying context data.
     *
     * @generated from protobuf enum value: PERMISSION_CONTEXT_WRITE = 10;
     */
    CONTEXT_WRITE = 10,
    /**
     * QUOTA_VIEW allows viewing quota usage.
     *
     * @generated from protobuf enum value: PERMISSION_QUOTA_VIEW = 11;
     */
    QUOTA_VIEW = 11,
    /**
     * QUOTA_MANAGE allows modifying quota policies.
     *
     * @generated from protobuf enum value: PERMISSION_QUOTA_MANAGE = 12;
     */
    QUOTA_MANAGE = 12,
    /**
     * BILLING_VIEW allows viewing billing data.
     *
     * @generated from protobuf enum value: PERMISSION_BILLING_VIEW = 13;
     */
    BILLING_VIEW = 13,
    /**
     * AUDIT_READ allows reading audit logs.
     *
     * @generated from protobuf enum value: PERMISSION_AUDIT_READ = 14;
     */
    AUDIT_READ = 14,
    /**
     * USER_MANAGE allows managing workspace users and roles.
     *
     * @generated from protobuf enum value: PERMISSION_USER_MANAGE = 15;
     */
    USER_MANAGE = 15,
    /**
     * TENANT_ADMIN allows full tenant administration.
     *
     * @generated from protobuf enum value: PERMISSION_TENANT_ADMIN = 16;
     */
    TENANT_ADMIN = 16,
    /**
     * FEDERATION_MANAGE allows managing federation policies.
     *
     * @generated from protobuf enum value: PERMISSION_FEDERATION_MANAGE = 17;
     */
    FEDERATION_MANAGE = 17,
    /**
     * SERVICE_AUTH allows service-to-service authentication.
     *
     * @generated from protobuf enum value: PERMISSION_SERVICE_AUTH = 18;
     */
    SERVICE_AUTH = 18,
    /**
     * SYSTEM_INTERNAL allows internal harness-to-harness operations.
     *
     * @generated from protobuf enum value: PERMISSION_SYSTEM_INTERNAL = 19;
     */
    SYSTEM_INTERNAL = 19
}
/**
 * CredentialType defines the type of credential being fetched.
 *
 * @generated from protobuf enum agency.auth.v1.CredentialType
 */
export enum CredentialType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: CREDENTIAL_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * TOOL credentials for tool execution.
     *
     * @generated from protobuf enum value: CREDENTIAL_TYPE_TOOL = 1;
     */
    TOOL = 1,
    /**
     * LLM credentials for LLM provider authentication.
     *
     * @generated from protobuf enum value: CREDENTIAL_TYPE_LLM = 2;
     */
    LLM = 2,
    /**
     * SERVICE credentials for service-to-service authentication.
     *
     * @generated from protobuf enum value: CREDENTIAL_TYPE_SERVICE = 3;
     */
    SERVICE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Claims$Type extends MessageType<Claims> {
    constructor() {
        super("agency.auth.v1.Claims", [
            { no: 1, name: "sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "role", kind: "enum", T: () => ["agency.auth.v1.RBACRole", RBACRole], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "iss", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 6, name: "aud", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 7, name: "iat", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "exp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "nbf", kind: "message", T: () => Timestamp },
            { no: 10, name: "jti", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 11, name: "scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9:._-]*[a-z0-9]$" } } } } } },
            { no: 12, name: "nats_account", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<Claims>): Claims {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sub = "";
        message.tenant = "";
        message.workspace = "";
        message.role = 0;
        message.iss = "";
        message.aud = [];
        message.jti = "";
        message.scopes = [];
        message.natsAccount = "";
        if (value !== undefined)
            reflectionMergePartial<Claims>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Claims): Claims {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sub */ 1:
                    message.sub = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* agency.auth.v1.RBACRole role */ 4:
                    message.role = reader.int32();
                    break;
                case /* string iss */ 5:
                    message.iss = reader.string();
                    break;
                case /* repeated string aud */ 6:
                    message.aud.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp iat */ 7:
                    message.iat = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.iat);
                    break;
                case /* google.protobuf.Timestamp exp */ 8:
                    message.exp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.exp);
                    break;
                case /* google.protobuf.Timestamp nbf */ 9:
                    message.nbf = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.nbf);
                    break;
                case /* string jti */ 10:
                    message.jti = reader.string();
                    break;
                case /* repeated string scopes */ 11:
                    message.scopes.push(reader.string());
                    break;
                case /* string nats_account */ 12:
                    message.natsAccount = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Claims, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sub = 1; */
        if (message.sub !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sub);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* agency.auth.v1.RBACRole role = 4; */
        if (message.role !== 0)
            writer.tag(4, WireType.Varint).int32(message.role);
        /* string iss = 5; */
        if (message.iss !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.iss);
        /* repeated string aud = 6; */
        for (let i = 0; i < message.aud.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.aud[i]);
        /* google.protobuf.Timestamp iat = 7; */
        if (message.iat)
            Timestamp.internalBinaryWrite(message.iat, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp exp = 8; */
        if (message.exp)
            Timestamp.internalBinaryWrite(message.exp, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp nbf = 9; */
        if (message.nbf)
            Timestamp.internalBinaryWrite(message.nbf, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string jti = 10; */
        if (message.jti !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.jti);
        /* repeated string scopes = 11; */
        for (let i = 0; i < message.scopes.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.scopes[i]);
        /* string nats_account = 12; */
        if (message.natsAccount !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.natsAccount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.Claims
 */
export const Claims = new Claims$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MintRequest$Type extends MessageType<MintRequest> {
    constructor() {
        super("agency.auth.v1.MintRequest", [
            { no: 1, name: "parent_claims", kind: "message", T: () => Claims, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "session", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "role", kind: "enum", T: () => ["agency.auth.v1.RBACRole", RBACRole], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 6, name: "ttl_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "86400", gt: "0" } } } },
            { no: 7, name: "scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9:._-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<MintRequest>): MintRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.session = "";
        message.role = 0;
        message.ttlSeconds = 0n;
        message.scopes = [];
        if (value !== undefined)
            reflectionMergePartial<MintRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MintRequest): MintRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.Claims parent_claims */ 1:
                    message.parentClaims = Claims.internalBinaryRead(reader, reader.uint32(), options, message.parentClaims);
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string session */ 4:
                    message.session = reader.string();
                    break;
                case /* agency.auth.v1.RBACRole role */ 5:
                    message.role = reader.int32();
                    break;
                case /* int64 ttl_seconds */ 6:
                    message.ttlSeconds = reader.int64().toBigInt();
                    break;
                case /* repeated string scopes */ 7:
                    message.scopes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MintRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.Claims parent_claims = 1; */
        if (message.parentClaims)
            Claims.internalBinaryWrite(message.parentClaims, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string session = 4; */
        if (message.session !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.session);
        /* agency.auth.v1.RBACRole role = 5; */
        if (message.role !== 0)
            writer.tag(5, WireType.Varint).int32(message.role);
        /* int64 ttl_seconds = 6; */
        if (message.ttlSeconds !== 0n)
            writer.tag(6, WireType.Varint).int64(message.ttlSeconds);
        /* repeated string scopes = 7; */
        for (let i = 0; i < message.scopes.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.scopes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.MintRequest
 */
export const MintRequest = new MintRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateRequest$Type extends MessageType<ValidateRequest> {
    constructor() {
        super("agency.auth.v1.ValidateRequest", [
            { no: 1, name: "claims", kind: "message", T: () => Claims, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "required_scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9:._-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ValidateRequest>): ValidateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requiredScopes = [];
        if (value !== undefined)
            reflectionMergePartial<ValidateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateRequest): ValidateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.Claims claims */ 1:
                    message.claims = Claims.internalBinaryRead(reader, reader.uint32(), options, message.claims);
                    break;
                case /* repeated string required_scopes */ 2:
                    message.requiredScopes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.Claims claims = 1; */
        if (message.claims)
            Claims.internalBinaryWrite(message.claims, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string required_scopes = 2; */
        for (let i = 0; i < message.requiredScopes.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.requiredScopes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.ValidateRequest
 */
export const ValidateRequest = new ValidateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateResponse$Type extends MessageType<ValidateResponse> {
    constructor() {
        super("agency.auth.v1.ValidateResponse", [
            { no: 1, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 3, name: "expires_in_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<ValidateResponse>): ValidateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.reason = "";
        message.expiresInSeconds = 0n;
        if (value !== undefined)
            reflectionMergePartial<ValidateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateResponse): ValidateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool valid */ 1:
                    message.valid = reader.bool();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                case /* int64 expires_in_seconds */ 3:
                    message.expiresInSeconds = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool valid = 1; */
        if (message.valid !== false)
            writer.tag(1, WireType.Varint).bool(message.valid);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* int64 expires_in_seconds = 3; */
        if (message.expiresInSeconds !== 0n)
            writer.tag(3, WireType.Varint).int64(message.expiresInSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.ValidateResponse
 */
export const ValidateResponse = new ValidateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RolePermissions$Type extends MessageType<RolePermissions> {
    constructor() {
        super("agency.auth.v1.RolePermissions", [
            { no: 1, name: "role", kind: "enum", T: () => ["agency.auth.v1.RBACRole", RBACRole], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "permissions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.auth.v1.Permission", Permission, "PERMISSION_"], options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "50", items: { enum: { definedOnly: true, notIn: [0] } } } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<RolePermissions>): RolePermissions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.role = 0;
        message.permissions = [];
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<RolePermissions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RolePermissions): RolePermissions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.RBACRole role */ 1:
                    message.role = reader.int32();
                    break;
                case /* repeated agency.auth.v1.Permission permissions */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.permissions.push(reader.int32());
                    else
                        message.permissions.push(reader.int32());
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RolePermissions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.RBACRole role = 1; */
        if (message.role !== 0)
            writer.tag(1, WireType.Varint).int32(message.role);
        /* repeated agency.auth.v1.Permission permissions = 2; */
        if (message.permissions.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.permissions.length; i++)
                writer.int32(message.permissions[i]);
            writer.join();
        }
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RolePermissions
 */
export const RolePermissions = new RolePermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FetchRequest$Type extends MessageType<FetchRequest> {
    constructor() {
        super("agency.auth.v1.FetchRequest", [
            { no: 1, name: "credential_type", kind: "enum", T: () => ["agency.auth.v1.CredentialType", CredentialType, "CREDENTIAL_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_]*[a-z0-9])?$" } } } },
            { no: 5, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } },
            { no: 6, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<FetchRequest>): FetchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialType = 0;
        message.tenant = "";
        message.workspace = "";
        message.toolName = "";
        message.provider = "";
        message.credentialKey = "";
        if (value !== undefined)
            reflectionMergePartial<FetchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FetchRequest): FetchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.CredentialType credential_type */ 1:
                    message.credentialType = reader.int32();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string tool_name */ 4:
                    message.toolName = reader.string();
                    break;
                case /* string provider */ 5:
                    message.provider = reader.string();
                    break;
                case /* string credential_key */ 6:
                    message.credentialKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FetchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.CredentialType credential_type = 1; */
        if (message.credentialType !== 0)
            writer.tag(1, WireType.Varint).int32(message.credentialType);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string tool_name = 4; */
        if (message.toolName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolName);
        /* string provider = 5; */
        if (message.provider !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.provider);
        /* string credential_key = 6; */
        if (message.credentialKey !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.credentialKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.FetchRequest
 */
export const FetchRequest = new FetchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FetchResponse$Type extends MessageType<FetchResponse> {
    constructor() {
        super("agency.auth.v1.FetchResponse", [
            { no: 1, name: "credential_type", kind: "enum", T: () => ["agency.auth.v1.CredentialType", CredentialType, "CREDENTIAL_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "65536" } } } },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 4, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "rotation_due_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "provider_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<FetchResponse>): FetchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialType = 0;
        message.secret = "";
        message.metadata = {};
        message.providerType = "";
        if (value !== undefined)
            reflectionMergePartial<FetchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FetchResponse): FetchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.CredentialType credential_type */ 1:
                    message.credentialType = reader.int32();
                    break;
                case /* string secret */ 2:
                    message.secret = reader.string();
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 4:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* google.protobuf.Timestamp rotation_due_at */ 5:
                    message.rotationDueAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.rotationDueAt);
                    break;
                case /* string provider_type */ 6:
                    message.providerType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: FetchResponse["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FetchResponse["metadata"] | undefined, val: FetchResponse["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.auth.v1.FetchResponse.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: FetchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.CredentialType credential_type = 1; */
        if (message.credentialType !== 0)
            writer.tag(1, WireType.Varint).int32(message.credentialType);
        /* string secret = 2; */
        if (message.secret !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.secret);
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* google.protobuf.Timestamp expires_at = 4; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp rotation_due_at = 5; */
        if (message.rotationDueAt)
            Timestamp.internalBinaryWrite(message.rotationDueAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string provider_type = 6; */
        if (message.providerType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.providerType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.FetchResponse
 */
export const FetchResponse = new FetchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialRotationEvent$Type extends MessageType<CredentialRotationEvent> {
    constructor() {
        super("agency.auth.v1.CredentialRotationEvent", [
            { no: 1, name: "credential_type", kind: "enum", T: () => ["agency.auth.v1.CredentialType", CredentialType, "CREDENTIAL_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 6, name: "rotated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "rotation_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 8, name: "next_rotation_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<CredentialRotationEvent>): CredentialRotationEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialType = 0;
        message.credentialKey = "";
        message.tenant = "";
        message.workspace = "";
        message.provider = "";
        message.rotationReason = "";
        if (value !== undefined)
            reflectionMergePartial<CredentialRotationEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialRotationEvent): CredentialRotationEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.CredentialType credential_type */ 1:
                    message.credentialType = reader.int32();
                    break;
                case /* string credential_key */ 2:
                    message.credentialKey = reader.string();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string provider */ 5:
                    message.provider = reader.string();
                    break;
                case /* google.protobuf.Timestamp rotated_at */ 6:
                    message.rotatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.rotatedAt);
                    break;
                case /* string rotation_reason */ 7:
                    message.rotationReason = reader.string();
                    break;
                case /* google.protobuf.Timestamp next_rotation_at */ 8:
                    message.nextRotationAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.nextRotationAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialRotationEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.CredentialType credential_type = 1; */
        if (message.credentialType !== 0)
            writer.tag(1, WireType.Varint).int32(message.credentialType);
        /* string credential_key = 2; */
        if (message.credentialKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.credentialKey);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string provider = 5; */
        if (message.provider !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.provider);
        /* google.protobuf.Timestamp rotated_at = 6; */
        if (message.rotatedAt)
            Timestamp.internalBinaryWrite(message.rotatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string rotation_reason = 7; */
        if (message.rotationReason !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.rotationReason);
        /* google.protobuf.Timestamp next_rotation_at = 8; */
        if (message.nextRotationAt)
            Timestamp.internalBinaryWrite(message.nextRotationAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.CredentialRotationEvent
 */
export const CredentialRotationEvent = new CredentialRotationEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterRequest$Type extends MessageType<RegisterRequest> {
    constructor() {
        super("agency.auth.v1.RegisterRequest", [
            { no: 1, name: "credential_type", kind: "enum", T: () => ["agency.auth.v1.CredentialType", CredentialType, "CREDENTIAL_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "65536" } } } },
            { no: 6, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 7, name: "ttl_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<RegisterRequest>): RegisterRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialType = 0;
        message.credentialKey = "";
        message.tenant = "";
        message.workspace = "";
        message.secret = "";
        message.metadata = {};
        message.ttlSeconds = 0n;
        if (value !== undefined)
            reflectionMergePartial<RegisterRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterRequest): RegisterRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.auth.v1.CredentialType credential_type */ 1:
                    message.credentialType = reader.int32();
                    break;
                case /* string credential_key */ 2:
                    message.credentialKey = reader.string();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string secret */ 5:
                    message.secret = reader.string();
                    break;
                case /* map<string, string> metadata */ 6:
                    this.binaryReadMap6(message.metadata, reader, options);
                    break;
                case /* int64 ttl_seconds */ 7:
                    message.ttlSeconds = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: RegisterRequest["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof RegisterRequest["metadata"] | undefined, val: RegisterRequest["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.auth.v1.RegisterRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: RegisterRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.auth.v1.CredentialType credential_type = 1; */
        if (message.credentialType !== 0)
            writer.tag(1, WireType.Varint).int32(message.credentialType);
        /* string credential_key = 2; */
        if (message.credentialKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.credentialKey);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string secret = 5; */
        if (message.secret !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.secret);
        /* map<string, string> metadata = 6; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* int64 ttl_seconds = 7; */
        if (message.ttlSeconds !== 0n)
            writer.tag(7, WireType.Varint).int64(message.ttlSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RegisterRequest
 */
export const RegisterRequest = new RegisterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterResponse$Type extends MessageType<RegisterResponse> {
    constructor() {
        super("agency.auth.v1.RegisterResponse", [
            { no: 1, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "registered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<RegisterResponse>): RegisterResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialKey = "";
        if (value !== undefined)
            reflectionMergePartial<RegisterResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterResponse): RegisterResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credential_key */ 1:
                    message.credentialKey = reader.string();
                    break;
                case /* google.protobuf.Timestamp registered_at */ 2:
                    message.registeredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registeredAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 3:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credential_key = 1; */
        if (message.credentialKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.credentialKey);
        /* google.protobuf.Timestamp registered_at = 2; */
        if (message.registeredAt)
            Timestamp.internalBinaryWrite(message.registeredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 3; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RegisterResponse
 */
export const RegisterResponse = new RegisterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateRequest$Type extends MessageType<RotateRequest> {
    constructor() {
        super("agency.auth.v1.RotateRequest", [
            { no: 1, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "credential_type", kind: "enum", T: () => ["agency.auth.v1.CredentialType", CredentialType, "CREDENTIAL_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "grace_period", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<RotateRequest>): RotateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialKey = "";
        message.credentialType = 0;
        message.tenant = "";
        message.workspace = "";
        if (value !== undefined)
            reflectionMergePartial<RotateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RotateRequest): RotateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credential_key */ 1:
                    message.credentialKey = reader.string();
                    break;
                case /* agency.auth.v1.CredentialType credential_type */ 2:
                    message.credentialType = reader.int32();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* google.protobuf.Duration grace_period */ 5:
                    message.gracePeriod = Duration.internalBinaryRead(reader, reader.uint32(), options, message.gracePeriod);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RotateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credential_key = 1; */
        if (message.credentialKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.credentialKey);
        /* agency.auth.v1.CredentialType credential_type = 2; */
        if (message.credentialType !== 0)
            writer.tag(2, WireType.Varint).int32(message.credentialType);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* google.protobuf.Duration grace_period = 5; */
        if (message.gracePeriod)
            Duration.internalBinaryWrite(message.gracePeriod, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RotateRequest
 */
export const RotateRequest = new RotateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateResponse$Type extends MessageType<RotateResponse> {
    constructor() {
        super("agency.auth.v1.RotateResponse", [
            { no: 1, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "rotated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "new_expires_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "grace_period_ends_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<RotateResponse>): RotateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialKey = "";
        if (value !== undefined)
            reflectionMergePartial<RotateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RotateResponse): RotateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credential_key */ 1:
                    message.credentialKey = reader.string();
                    break;
                case /* google.protobuf.Timestamp rotated_at */ 2:
                    message.rotatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.rotatedAt);
                    break;
                case /* google.protobuf.Timestamp new_expires_at */ 3:
                    message.newExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.newExpiresAt);
                    break;
                case /* google.protobuf.Timestamp grace_period_ends_at */ 4:
                    message.gracePeriodEndsAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.gracePeriodEndsAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RotateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credential_key = 1; */
        if (message.credentialKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.credentialKey);
        /* google.protobuf.Timestamp rotated_at = 2; */
        if (message.rotatedAt)
            Timestamp.internalBinaryWrite(message.rotatedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp new_expires_at = 3; */
        if (message.newExpiresAt)
            Timestamp.internalBinaryWrite(message.newExpiresAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp grace_period_ends_at = 4; */
        if (message.gracePeriodEndsAt)
            Timestamp.internalBinaryWrite(message.gracePeriodEndsAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RotateResponse
 */
export const RotateResponse = new RotateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeRequest$Type extends MessageType<RevokeRequest> {
    constructor() {
        super("agency.auth.v1.RevokeRequest", [
            { no: 1, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "credential_type", kind: "enum", T: () => ["agency.auth.v1.CredentialType", CredentialType, "CREDENTIAL_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<RevokeRequest>): RevokeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialKey = "";
        message.credentialType = 0;
        message.tenant = "";
        message.workspace = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<RevokeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RevokeRequest): RevokeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credential_key */ 1:
                    message.credentialKey = reader.string();
                    break;
                case /* agency.auth.v1.CredentialType credential_type */ 2:
                    message.credentialType = reader.int32();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string reason */ 5:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RevokeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credential_key = 1; */
        if (message.credentialKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.credentialKey);
        /* agency.auth.v1.CredentialType credential_type = 2; */
        if (message.credentialType !== 0)
            writer.tag(2, WireType.Varint).int32(message.credentialType);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string reason = 5; */
        if (message.reason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RevokeRequest
 */
export const RevokeRequest = new RevokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeResponse$Type extends MessageType<RevokeResponse> {
    constructor() {
        super("agency.auth.v1.RevokeResponse", [
            { no: 1, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "revoked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RevokeResponse>): RevokeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialKey = "";
        if (value !== undefined)
            reflectionMergePartial<RevokeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RevokeResponse): RevokeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credential_key */ 1:
                    message.credentialKey = reader.string();
                    break;
                case /* google.protobuf.Timestamp revoked_at */ 2:
                    message.revokedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.revokedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RevokeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credential_key = 1; */
        if (message.credentialKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.credentialKey);
        /* google.protobuf.Timestamp revoked_at = 2; */
        if (message.revokedAt)
            Timestamp.internalBinaryWrite(message.revokedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RevokeResponse
 */
export const RevokeResponse = new RevokeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialCacheEntry$Type extends MessageType<CredentialCacheEntry> {
    constructor() {
        super("agency.auth.v1.CredentialCacheEntry", [
            { no: 1, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "credential_type", kind: "enum", T: () => ["agency.auth.v1.CredentialType", CredentialType, "CREDENTIAL_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "65536" } } } },
            { no: 4, name: "cached_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "expires_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<CredentialCacheEntry>): CredentialCacheEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialKey = "";
        message.credentialType = 0;
        message.secret = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<CredentialCacheEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialCacheEntry): CredentialCacheEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credential_key */ 1:
                    message.credentialKey = reader.string();
                    break;
                case /* agency.auth.v1.CredentialType credential_type */ 2:
                    message.credentialType = reader.int32();
                    break;
                case /* string secret */ 3:
                    message.secret = reader.string();
                    break;
                case /* google.protobuf.Timestamp cached_at */ 4:
                    message.cachedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.cachedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 5:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* map<string, string> metadata */ 6:
                    this.binaryReadMap6(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: CredentialCacheEntry["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CredentialCacheEntry["metadata"] | undefined, val: CredentialCacheEntry["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.auth.v1.CredentialCacheEntry.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: CredentialCacheEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credential_key = 1; */
        if (message.credentialKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.credentialKey);
        /* agency.auth.v1.CredentialType credential_type = 2; */
        if (message.credentialType !== 0)
            writer.tag(2, WireType.Varint).int32(message.credentialType);
        /* string secret = 3; */
        if (message.secret !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.secret);
        /* google.protobuf.Timestamp cached_at = 4; */
        if (message.cachedAt)
            Timestamp.internalBinaryWrite(message.cachedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 5; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 6; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.CredentialCacheEntry
 */
export const CredentialCacheEntry = new CredentialCacheEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevocationEvent$Type extends MessageType<RevocationEvent> {
    constructor() {
        super("agency.auth.v1.RevocationEvent", [
            { no: 1, name: "sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "jti", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "revoked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "revoked_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<RevocationEvent>): RevocationEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sub = "";
        message.tenant = "";
        message.jti = "";
        message.reason = "";
        message.revokedBy = "";
        if (value !== undefined)
            reflectionMergePartial<RevocationEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RevocationEvent): RevocationEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sub */ 1:
                    message.sub = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string jti */ 3:
                    message.jti = reader.string();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp revoked_at */ 5:
                    message.revokedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.revokedAt);
                    break;
                case /* string revoked_by */ 6:
                    message.revokedBy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RevocationEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sub = 1; */
        if (message.sub !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sub);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string jti = 3; */
        if (message.jti !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.jti);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp revoked_at = 5; */
        if (message.revokedAt)
            Timestamp.internalBinaryWrite(message.revokedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string revoked_by = 6; */
        if (message.revokedBy !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.revokedBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.auth.v1.RevocationEvent
 */
export const RevocationEvent = new RevocationEvent$Type();
/**
 * @generated ServiceType for protobuf service agency.auth.v1.CredentialProviderService
 */
export const CredentialProviderService = new ServiceType("agency.auth.v1.CredentialProviderService", [
    { name: "Fetch", options: {}, I: FetchRequest, O: FetchResponse },
    { name: "Register", options: {}, I: RegisterRequest, O: RegisterResponse },
    { name: "Rotate", options: {}, I: RotateRequest, O: RotateResponse },
    { name: "Revoke", options: {}, I: RevokeRequest, O: RevokeResponse }
]);
